import React from 'react';
import { Field } from 'redux-form';

const WrappedTextInput = ({ input, label, name, type, width, ...props }) => (
  <div className="input">
    {label && <label className="input__label" htmlFor={name}>{label}</label>}
    <input type={type} name={name} style={{width: width}} {...props} {...input} />
  </div>
);

WrappedTextInput.defaultProps = {
  type: 'text',
};

const TextField = props => (
  <Field
    component={WrappedTextInput}
    {...props}
  />
);

export default TextField;
